export default {
  title: 'Components/Navigation/cobalt-tabs-horizontal',
  tags: ['autodocs'],
  argTypes: {
    stretch: {
      type: { name: 'string' },
      control: { type: 'boolean' },
      description: 'Force the tab labels to have the same size and take the full width of the tabs component.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: false }
      }
    },
    iconPosition: {
      type: { name: 'string' },
      control: { type: 'radio' },
      options: ['top', 'left'],
      description: 'Change the position of the icon for all tabs.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: 'left' }
      }
    },
    activeTabIndex: {
      type: { name: 'number' },
      control: { type: 'number' },
      description: 'Set a tab as active by providing the index (tab can not be disabled)',
      table: {
        type: { summary: 'number' },
        defaultValue: { summary: 0 }
      }
    },
    previousButtonLabel: {
      type: { name: 'string' },
      control: { type: 'string' },
      description: 'Label of the previous button.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'Précédent' }
      }
    },
    nextButtonLabel: {
      type: { name: 'string' },
      control: { type: 'string' },
      description: 'Label of the next button.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'Suivant' }
      }
    },
    cobaltTabChange: {
      action: 'cobaltTabChange',
      description: 'Custom event emitted on tab index change, containing the current (currentTab) and the previous tab (previousTab)',
      table: {
        type: {
          summary: 'Framework integration',
          detail:
            'React: onCobaltTabChange={handleChange}\nVue:@cobaltTabChange="handleChange"\nAngular:(cobaltTabChange)="handleChange()"\nVanillaJs:.addEventListener("cobaltTabChange", (event) => {//handle change});'
        }
      }
    }
  }
}

const Template = args => {
  return `
<style>
  .custom-panel-content-class {
    padding: var(--number-spacing-medium) 0;
  }
</style>
<cobalt-tabs-horizontal icon-position="${args.iconPosition}" stretch="${args.stretch}" active-tab-index="${args.activeTabIndex}" previous-button-label="${args.previousButtonLabel}" next-button-label="${args.nextButtonLabel}">
  <cobalt-tab-panel label="Tab 1" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 2" disabled="true" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">Disabled panel</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 3" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
  </cobalt-tab-panel>
</cobalt-tabs-horizontal>
`
}

export const Default = Template.bind({})
Default.args = {
  iconPosition: 'left',
  stretch: false,
  activeTabIndex: 0,
  previousButtonLabel: 'Précédent',
  nextButtonLabel: 'Suivant'
}

const TemplateWithNotificationPill = args => {
  return `
<style>
  .custom-panel-content-class {
    padding: var(--number-spacing-medium) 0;
  }
</style>
<cobalt-tabs-horizontal icon-position="${args.iconPosition}">
  <cobalt-tab-panel label="Tab 1" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 2" disabled="true" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">Disabled panel</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 3" icon-name="star-outline" notification-pill-number="2">
    <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
  </cobalt-tab-panel>
</cobalt-tabs-horizontal>
`
}

export const WithNotificationPill = TemplateWithNotificationPill.bind({})
WithNotificationPill.args = {
  iconPosition: 'left'
}

const TemplateWithOverflow = args => {
  return `
<style>
  .narrow-tabs {
    width: 400px;
  }
  .custom-panel-content-class {
    padding: var(--number-spacing-medium) 0;
  }
</style>
<cobalt-tabs-horizontal class="narrow-tabs" icon-position="${args.iconPosition}">
  <cobalt-tab-panel label="Tab 1" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 2" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">Content 2</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 3" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 4" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 4</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 5" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 5</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 6" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 6</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 7" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 7</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 8" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 8</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 9" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 9</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 10" icon-name="star-outline">
    <div class="custom-panel-content-class typography-body-medium-regular">content 10</div>
  </cobalt-tab-panel>
</cobalt-tabs-horizontal>
`
}

export const WithOverflow = TemplateWithOverflow.bind({})
WithOverflow.args = {
  iconPosition: 'left'
}

const TemplateOnChangeEvent = () => {
  return `
<style>
  .custom-panel-content-class {
    padding: var(--number-spacing-medium) 0;
  }
</style>
<script>
  document.querySelector('#tab-on-change').addEventListener('cobaltTabChange', (e) => {
    document.querySelector('#tab-change-infos').textContent = JSON.stringify(e.detail)
  })
</script>
<div style="display:flex; flex-direction: column; gap: var(--number-spacing-large);">
  <p class="typography-body-medium-regular">tabs infos sent on change: <span id="tab-change-infos">no event emitted yet</span></p>
  <cobalt-tabs-horizontal id="tab-on-change">
    <cobalt-tab-panel label="Tab 1">
      <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
    </cobalt-tab-panel>
    <cobalt-tab-panel label="Tab 2">
      <div class="custom-panel-content-class typography-body-medium-regular">content 2</div>
    </cobalt-tab-panel>
    <cobalt-tab-panel label="Tab 3">
      <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
    </cobalt-tab-panel>
  </cobalt-tabs-horizontal>
</div>
`
}

export const OnChangeEvent = TemplateOnChangeEvent.bind({})
